import React, { useState, useEffect } from 'react';
import moment from 'moment/moment';
import { useLocation, useNavigate } from 'react-router-dom';

//Components
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import MainCard from '../../../components/MainCard/MainCard';
import DetalhesColetasRecusadas from './DetalhesColetasRecusadas';
import Loading from '../../../components/Loading/Loading';
import TextField from '../../../components/TextField/TextField';

//Api
import coletasRecusadas_api from '../../../api/coletasRecusadas_api';
import transportador_api from '../../../api/transportador_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { getSessionCookie } from 'helpers/cookies';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';
export default function ColetasRecusadas() {
    //Estado de controle para pegar os dados que vem na rota
    const location = useLocation();

    //Variavel de navegação
    const navigate = useNavigate();

    //Ações da tabela
    const actions = [actionsTable.visualizar((item) => setFicha(item.id))];

    //Dados do usuario logado
    const usuario = getSessionCookie();

    //Lista de transportadores
    const [transportadores, setTransportadores] = useState([]);

    //Estado que guarda o transportador selecionado
    const [transportador, setTransportador] = useState(null);

    //Estado que guarda a lista das coletas recusadas
    const [coletasRecusadas, setColetasRecusadas] = useState([]);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Carrega a lista de coletas recusadas
    const loadColetasRecusadas = (transportadorId = 0) => {
        setLoading(true);
        coletasRecusadas_api.GetList(transportadorId, location.state ? location.state.filtros : { dataInicial: null, dataFinal: null }).then(response => {
            response.data = response.data.map(value => {
                value.dataHora = moment(value.dataHora).format("DD/MM/YYYY HH:mm:ss");
                return value;
            })
            setColetasRecusadas(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Carrega os transportadores para serem listados no select
    const loadTransportadores = () => {
        setLoading(true);
        transportador_api.GetAll().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.fantasia };
            })
            setTransportadores(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Carrega os transportadores assim que a tela é inicializada
    useEffect(() => {
        if (usuario.ambiente === "Público" && usuario.acesso.sigla === "GS")
            loadTransportadores();
        else if (usuario.acesso.sigla === "TR")
            loadColetasRecusadas();
    }, []);

    //Controle da exibição da ficha da coleta recusada
    const [ficha, setFicha] = useState(false);

    //cabeçalhos da tabela
    const headers = [
        { value: "Data da recusa", objectValue: "dataHora" },
        { value: "Destino", objectValue: "destino" },
        { value: "Veículo", objectValue: "placaVeiculo" },
        { value: "Motorista", objectValue: "motorista" },
        { value: "Motivo da Recusa", objectValue: "justificativa" },
    ]

    if (ficha) {
        return <DetalhesColetasRecusadas btnVoltar={() => {
            setFicha(false);
            loadColetasRecusadas(transportador ? transportador.value : 0);
        }} id={ficha} transportadorId={transportador ? transportador.value : 0} />
    }
    return (
        <MainCard btnVoltar={location.state && location.state.btnVoltar ? () => navigate(-1) : null} noCard>
            {loading && <Loading />}
            {usuario.ambiente === "Público" && usuario.acesso.sigla === "GS" &&
                <TextField label={"Transportador"} type="select" searchable options={transportadores} onChange={(e) => {
                    setTransportador(e);
                    loadColetasRecusadas(e.value);
                }} value={transportador} />
            }
            <div className="mt-4">
                <TabelaListagem actions={actions} headers={headers} items={coletasRecusadas} title="Lista de coletas recusadas" options={{ print: false, search: true, pagination: true }} />
            </div>
        </MainCard>
    )
}